/*
 * @Descripttion: '登录时传递需要完善学制的学校列表'
 * @Author: zc
 * @Date: 2020-05-29 14:07:11
 * @LastEditors: zc
 * @LastEditTime: 2020-05-29 14:26:28
 */
var state = {
  schoolList: []
};
var getter = {
  schoolList: function schoolList(state) {
    return state.schoolList;
  }
};
var mutations = {
  SET_SCHOOL: function SET_SCHOOL(state, val) {
    state.setSchool = val;
  }
};
var actions = {
  setSchool: function setSchool(_ref, res) {
    var commit = _ref.commit;
    commit('SET_SCHOOL', res);
  }
};
export default {
  state: state,
  getter: getter,
  mutations: mutations,
  actions: actions,
  namespaced: true
};